import React from "react";

import { Help } from "@churchofjesuschrist/eden-icons";

import stringHasValue from "../../../utils/string-has-value";
import withStrings from "../../../utils/strings/with-strings";
import useManagedStrings from "../../../utils/use-managed-strings";
import {
  ColoredButton,
  StyledWrapper,
  TextHolder,
} from "../button-styled-components";


const stringGroups = [{ name: "shared", keys: ["help"] }];

const StringsButton = ({ onClick, strings, customText, ...others }) => {
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);
  const {justIcon = false} = others;
  return (
    <ColoredButton {...others} onClick={onClick}>
      <StyledWrapper>
        <Help />
      </StyledWrapper>
      {!justIcon && <TextHolder>{stringHasValue(customText) ? customText : useStrings.help}</TextHolder>}
    </ColoredButton>
  );
};

const HelpButton = ({ onClick, customText, ...others }) => {
  const Stringified = withStrings(StringsButton);
  return <Stringified onClick={onClick} customText={customText} {...others} />;
};

export default HelpButton;
